export const ONE_KILOBYTE = 1000;
export const ONE_MEGABYTE = ONE_KILOBYTE * 1000;
